var _excluded = ["buttonLabel", "expandableContent", "disabled", "onExpand"];
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Collapse, StepLabel as MuiStepLabel, withStyles } from '@material-ui/core';
import { CheckCircleFillIcon, ChevronDownOutlineIcon, ChevronRightCircleFillIcon, ChevronUpOutlineIcon, CircleOutlineIcon } from '@applyboard/ui-icons';
import styled from 'styled-components';
import { Typography } from "../Typography";
import { Button } from "../Button";
import { Box } from "../Box";
import { useId } from "../../hooks";
var StyledStepLabel = withStyles({
  labelContainer: {
    '& .MuiStepLabel-alternativeLabel': {
      marginTop: '8px'
    }
  }
})(MuiStepLabel);
export function StepLabel(props) {
  return /*#__PURE__*/React.createElement(StyledStepLabel
  // I don't really like this but we probably have to use prop spread here
  // because MUI injects some props into StepLabel and it's not documented
  , _extends({}, props, {
    StepIconComponent: StepIcon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    component: "span"
    // These colors are nowhere in the ui-components theme or color constants, so
    // hard-coding for now. (They are in crystal-ui, but I don't want to
    // introduce a dependency on crystal-ui from ui-components)  I think the
    // design team updated the colors but we didn't update ui-components.
    // See: https://applyboard.atlassian.net/browse/UIE-182
    // See: https://applyboard.slack.com/archives/C021LRQHB3M/p1648569852589129
    ,
    style: {
      color: props.completed || props.active ? '#363B51' : '#616D92',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      textOverflow: 'ellipsis',
      overflowX: 'hidden'
    }
  }, props.children));
}
export function ExpandableStepLabel(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var buttonLabel = props.buttonLabel,
    expandableContent = props.expandableContent,
    disabled = props.disabled,
    onExpand = props.onExpand,
    stepLabelProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var regionId = useId();
  var buttonId = useId();
  return /*#__PURE__*/React.createElement(StyledStepLabel
  // I don't really like this but we probably have to use prop spread here
  // because MUI injects some props into StepLabel and it's not documented
  , _extends({}, stepLabelProps, {
    StepIconComponent: StepIcon
  }), /*#__PURE__*/React.createElement(Box, {
    mt: -1
  }, /*#__PURE__*/React.createElement(StretchIntoSidePadding, null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "secondary",
    disableRipple: false,
    disableFocusRipple: false,
    onClick: function onClick() {
      setExpanded(!expanded);
      if (onExpand) {
        onExpand();
      }
    },
    id: buttonId,
    "aria-expanded": expanded,
    "aria-controls": regionId,
    fullWidth: true,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    component: "span"
    // This color is nowhere in the ui-components theme or color
    // constants, so hard-coding for now. (It is in crystal-ui, but
    // I don't want to introduce a dependency on crystal-ui from
    // ui-components)  I think the design team updated the colors
    // but we didn't update ui-components.
    // See: https://applyboard.atlassian.net/browse/UIE-182
    // See: https://applyboard.slack.com/archives/C021LRQHB3M/p1648569852589129
    ,
    style: {
      color: '#363B51',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    mr: 0.5
  }, buttonLabel), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    style: {
      flexGrow: 0,
      flexShrink: 0
    }
  }, expanded ? /*#__PURE__*/React.createElement(ChevronUpOutlineIcon, null) : /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null))))), /*#__PURE__*/React.createElement(Collapse, {
    id: regionId,
    role: "region",
    "in": expanded,
    "aria-labelledby": buttonId
  }, expandableContent)));
}
function StepIcon(props) {
  var active = props.active,
    completed = props.completed;
  if (completed) {
    return /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
      intent: "positive"
    });
  }
  if (active) {
    return /*#__PURE__*/React.createElement(ChevronRightCircleFillIcon, {
      intent: "primary"
    });
  }
  return /*#__PURE__*/React.createElement(CircleOutlineIcon, {
    intent: "secondary"
  });
}
var StretchIntoSidePadding = styled.div(function (_ref) {
  var theme = _ref.theme;
  return {
    marginLeft: "-".concat(theme.spacing(1), "px"),
    width: "calc(100% + ".concat(theme.spacing(1) * 2, "px)")
  };
});